import getProviderBrandName from '../utils/getProviderBrandName';
import strings from 'owa-strings/owa-mail-strings';
import { clearFileProviderToken } from 'owa-fileprovider-items-service';
import { confirm } from 'owa-confirm-dialog';
import { fileProviderRemoved } from '../actions/subscribableActions';
import { FileProviderType } from '../utils/constants';
import { format } from 'owa-strings';
import { orchestrator } from 'satcheljs';
import { remove } from '../actions/internalActions';
import { removeFileProvider } from '../actions/publicActions';
import { trace } from 'owa-trace';
import { getFileProvider } from '../selectors/getFileProviders';
import isFileProviderAddable from '../utils/isFileProviderAddable';
import RemoveAttachmentDataProviderResponse from 'owa-service/lib/contract/RemoveAttachmentDataProviderResponse';
import removeFileProviderService from '../services/removeFileProvider';

orchestrator(removeFileProvider, actionMessage => {
    removeFileProviderOrchestrator(actionMessage.providerType);
});

export default async function removeFileProviderOrchestrator(providerType: FileProviderType) {
    const provider = getFileProvider(providerType.toString());

    if (!provider || !isFileProviderAddable(providerType)) {
        handleError(
            'Unable to remove the provider as the provider does not exist in the store or is not addable.',
            providerType
        );
        return;
    }
    const removeResponse: RemoveAttachmentDataProviderResponse = await removeFileProviderService(
        provider.model.Id
    );

    if (!removeResponse.RemovedSuccessfuly) {
        handleError('Unable to remove the provider', provider.type);
    } else {
        remove(providerType);
        fileProviderRemoved(providerType);
        // When we remove the provider we clear any
        // associated token (if any) so that if the user
        // adds the provider again we use the new token
        clearFileProviderToken(provider.type);
    }
}

function handleError(errorMessage: string, providerType: FileProviderType) {
    trace.warn(`Error in removing file provider ${errorMessage}`);
    showRemoveProviderErrorDialog(getProviderBrandName(providerType));
}

function showRemoveProviderErrorDialog(providerDisplayName: string) {
    confirm(
        strings.ErrorRemovingProviderTitleText,
        format(strings.ErrorRemovingProviderDescriptionText, providerDisplayName),
        false,
        {
            hideCancelButton: true,
        }
    );
}
